export const CREATE_REMORQUE = "CREATE_REMORQUE";
export const RETRIEVE_REMORQUES = "RETRIEVE_REMORQUES";
export const UPDATE_REMORQUE = "UPDATE_REMORQUE";
export const DELETE_REMORQUE = "DELETE_REMORQUE";
export const DELETE_ALL_REMORQUES = "DELETE_ALL_REMORQUES";

